let superProperties = {
  'User Type': 'Anonymous',
};

export function setSuperProperties(props = {}) {
  superProperties = { ...superProperties, ...props };

  return superProperties;
}

export function getSuperProperties() {
  return superProperties;
}



// WEBPACK FOOTER //
// ./events/superProperties.js